import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from "@angular/core";
import { NewOrganisationProfileDTO, OrganisationProfile, StoreProfilePost } from '@portal-front-end/models';
import { Observable } from 'rxjs';
import { API_SERVER_TOKEN } from '../api-server-token';

@Injectable({ providedIn: 'root' })
export class OrganisationProfileApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly ORGANISATION_PROFILE_API_URL = `${this.apiServer}/organisation-profiles`;

    getAllOrganisationProfilesByOrganisation(orgId: string): Observable<OrganisationProfile[]> {
        return this.http.get<OrganisationProfile[]>(`${this.ORGANISATION_PROFILE_API_URL}/search`, {
            params: {
                'profileOrganisationId': orgId
            }
        });
    }
    // TODO:duplicate endpoint
    getAllStoresByOrganisationProfiles(orgId: string, profileId: string): Observable<OrganisationProfile[]> {
        return this.http.get<OrganisationProfile[]>(`${this.ORGANISATION_PROFILE_API_URL}/search`, {
            params: {
                'profileOrganisationId': orgId,
                'profileId': profileId
            }
        });
    }
    //Get ACTIVE Store + Pricing profile mapping.
    getAllActiveStores():Observable<OrganisationProfile[]>{
        return this.http.get<OrganisationProfile[]>(`${this.ORGANISATION_PROFILE_API_URL}/active-stores`)
    }

    createOrganisationProfile(entity: OrganisationProfile): Observable<OrganisationProfile> {
        return this.http.post<OrganisationProfile>(`${this.ORGANISATION_PROFILE_API_URL}`, entity);
    }

    deleteOrganisationProfile(orgId: string, profileId: number): Observable<string | number> {
        return this.http.delete<string | number>(`${this.ORGANISATION_PROFILE_API_URL}/${orgId}/${profileId}`, {
            responseType: 'text' as 'json'
        });

    }
    // Added Profiles to Export
    getAllProfilesToExport(orgId: string): Observable<HttpResponse<Blob>> {
        return this.http.get<Blob>(`${this.ORGANISATION_PROFILE_API_URL}/export`, {
            params: { 'organisationId': orgId },
            responseType: 'blob' as 'json',
            observe: 'response'
        });
    }

    // given a list of store ids, associate these stores to a particular profile.
    bulkUpdateStoreForOrganisationProfile(profileId:number, organisationIdList: string[]): Observable<any> {
        return this.http.post<any>(`${this.ORGANISATION_PROFILE_API_URL}/bulk-update`,{
            profileId: profileId,
            organisationIdList: organisationIdList
        });
    }
}